import s from "prop-types";
import e, { Component as p } from "react";
import { withTranslation as d } from "react-i18next";
import './Spinner.css';const m = "#519de9", u = "Spinner-module__circle___lZ-ky", g = "Spinner-module__spin___MVDN-", r = {
  lightBlue: m,
  circle: u,
  spin: g,
  "hidden-span": "Spinner-module__hidden-span___rSb24"
};
class o extends p {
  constructor(t) {
    super(t), this.getArcLength = this.getArcLength.bind(this), this.drawArc = this.drawArc.bind(this), this.drawCircle = this.drawCircle.bind(this), this.state = {
      strokeDasharray: 0,
      strokeDashoffset: 0,
      transitionDuration: 0
    };
  }
  componentDidMount() {
    this.drawCircle(0);
  }
  componentWillUnmount() {
    clearTimeout(this.drawCircleTimeout);
  }
  getArcLength(t) {
    return t * Math.PI * (this.props.size - this.props.thickness);
  }
  drawArc(t, i, a) {
    const h = `${this.getArcLength(
      t
    )}, ${this.getArcLength(1)}`, c = this.getArcLength(i), l = `${a}ms`;
    this.setState({
      strokeDasharray: h,
      strokeDashoffset: c,
      transitionDuration: l
    });
  }
  drawCircle(t) {
    const i = t % 3;
    i === 0 ? this.drawArc(0, 0, 0) : i === 1 ? this.drawArc(0.7, -0.3, 750) : this.drawArc(0.7, -1, 850), this.props.animated && (clearTimeout(this.drawCircleTimeout), this.drawCircleTimeout = setTimeout(
      this.drawCircle.bind(null, t + 1),
      i === 0 ? 250 : 750
    ));
  }
  render() {
    const { t } = this.props;
    return /* @__PURE__ */ e.createElement("div", { style: this.props.style, className: this.props.className }, /* @__PURE__ */ e.createElement("span", { role: this.props.role, className: r["hidden-span"] }, t("loading")), /* @__PURE__ */ e.createElement(
      "div",
      {
        className: r.spin,
        style: { width: this.props.size, height: this.props.size }
      },
      /* @__PURE__ */ e.createElement(
        "svg",
        {
          viewBox: `0 0 ${this.props.size} ${this.props.size}`,
          style: {
            width: this.props.size,
            height: this.props.size
          }
        },
        /* @__PURE__ */ e.createElement(
          "circle",
          {
            className: r.circle,
            stroke: this.props.color,
            cx: this.props.size / 2,
            cy: this.props.size / 2,
            r: (this.props.size - this.props.thickness) / 2,
            fill: "none",
            strokeWidth: this.props.thickness,
            strokeMiterlimit: "20",
            strokeDasharray: this.state.strokeDasharray,
            strokeDashoffset: this.state.strokeDashoffset,
            style: {
              transitionDuration: this.state.transitionDuration
            }
          }
        )
      )
    ));
  }
}
o.propTypes = {
  /** internal prop, will always be true */
  animated: s.bool,
  /** set the size of the spinner */
  size: s.number,
  /** Set the thickness of the spinner */
  thickness: s.number,
  /** extra styles object */
  // eslint-disable-next-line react/forbid-prop-types
  style: s.object,
  /** class name for additonal styles */
  className: s.string,
  /** spinner color */
  color: s.string,
  /**
   * ARIA role for screen readers:
   *  - `status`: Default. Use when this is a passive loading indicator (e.g. fetching data quietly in the background).
   *  - `alert`: Use when the loading is critical and user should be immediately informed (e.g. blocking action). Can create a lot of noise if many items loading.
   *  - `presentation`: Use when the loading animation is purely decorative and should be ignored by screen readers.
   * */
  role: s.oneOf(["status", "alert", "presentation"]),
  t: s.func.isRequired
};
o.defaultProps = {
  animated: !0,
  size: 40,
  thickness: 3.5,
  style: {},
  className: void 0,
  color: r.lightBlue,
  role: "status"
};
const f = d()(o), w = (n) => /* @__PURE__ */ e.createElement(f, { ...n, animated: !0 });
w.displayName = "Spinner";
export {
  w as S
};
